module.exports = __webpack_public_path__ + "img/group_man1.9a0f3fce.svg";